"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderComponent = void 0;
var app_1 = require("app");
var AppSwitcher_1 = require("./AppSwitcher");
var Menu_1 = require("./Menu");
var MenuService_1 = require("./MenuService");
var HeaderComponent = /** @class */ (function (_super) {
    __extends(HeaderComponent, _super);
    function HeaderComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = ".header";
        _this.stickyHeaderClass = "header--sticky";
        _this.stickyHeaderHiddenClass = "header--sticky-hidden";
        _this.touch = false;
        _this.mobileHeaderActive = true;
        _this.OnScrollThrottle = function () {
            if (MenuService_1.MobileSidebarService.getHeaderHidingStatus() && (0, app_1.detectBreakpoint)(3 /* Breakpoint.UpToTablet */)) {
                var currentPageYOffset = window.pageYOffset;
                var headerHeight = _this.$el.height();
                if ((Math.abs(currentPageYOffset) > Math.abs(_this.lastPageYOffset))
                    && currentPageYOffset > headerHeight) {
                    _this.$el.addClass(_this.stickyHeaderHiddenClass);
                }
                else {
                    _this.$el.removeClass(_this.stickyHeaderHiddenClass);
                }
                _this.lastPageYOffset = currentPageYOffset;
            }
        };
        _this.ActiveHeaderHiding = function (activeHeader) {
            _this.mobileHeaderActive = activeHeader;
        };
        return _this;
    }
    HeaderComponent.prototype.BeforeInit = function () {
        this.$menuComponent = this.$el.find(".header__secondary-menu");
        this.$menuButton = this.$el.find(".header__menu-btn");
        this.$body = $(document.body);
        this.$mainContent = this.$body.find(".main-content");
        this.$mobileMenu = this.$body.find(".header__mobile-menu-wrapper");
        this.$searchComponent = this.$body.find(".header__search-wrapper");
        this.$appSwitcherContainer = this.$el.find(".header__menu__item--app__switcher");
    };
    HeaderComponent.prototype.OnInit = function () {
        this.lastPageYOffset = window.pageYOffset;
        this.InitSearch();
        var mobileMenu = this.$mobileMenu;
        var headerControls = app_1.AttrService.data(mobileMenu, "header-controls");
        var menuItems = app_1.AttrService.data(mobileMenu, "megamenu-items");
        var pageId = app_1.AttrService.data(mobileMenu, "page-id");
        var loginMenu = app_1.AttrService.data(mobileMenu, "login-menu");
        var googleAnalytics = app_1.AttrService.data(mobileMenu, "google-analytics");
        (0, Menu_1.RenderMenu)({
            headerControls: headerControls,
            menuItems: menuItems,
            pageId: pageId,
            loginMenu: loginMenu,
            googleAnalytics: googleAnalytics
        }, this.$mobileMenu.get(0));
        // render appSwitcher;
        (0, AppSwitcher_1.RenderAppSwitcher)({
            className: "",
            language: headerControls.siteLanguageLabel,
            googleAnalytics: googleAnalytics
        }, this.$appSwitcherContainer.get(0));
        this.InitStickyHeader();
    };
    HeaderComponent.prototype.OnWindowResizeThrottle = function () {
        this.UpdateMainContentPosition();
    };
    HeaderComponent.prototype.OnTouchStart = function () {
        this.lastPageYOffset = window.pageYOffset;
        this.touch = true;
    };
    HeaderComponent.prototype.OnTouchEnd = function () {
        this.touch = false;
    };
    HeaderComponent.prototype.InitStickyHeader = function () {
        this.$el.addClass(this.stickyHeaderClass);
        this.UpdateMainContentPosition();
    };
    HeaderComponent.prototype.InitSearch = function () {
        var searchComponent = this.$searchComponent;
        /* const placeholder     = AttrService.data(searchComponent, "placeholder");
        const autoSuggestUrl  = AttrService.data(searchComponent, "api-url");
        const allResultsLabel = AttrService.data(searchComponent, "all-search-label");
        const searchPageUrl   = AttrService.data(searchComponent, "search-url");
        const searchPageId    = AttrService.data(searchComponent, "page-id");
        const autosuggestionRedirect = !$("#search-results-page-react").length;
        RenderSearchComponent({
            allResultsLabel,
            autoSuggestUrl,
            autosuggestionRedirect,
            placeholder,
            searchPageId,
            searchPageUrl
        }, this.$searchComponent.get(0));*/
    };
    HeaderComponent.prototype.UpdateMainContentPosition = function () {
        var $openedMenu = this.$el.find(".header__next-levels-menu");
        var openedMenuHeight = $openedMenu.length > 0 ? $openedMenu.innerHeight() : 0;
        var currentHeight = this.$el.height() - openedMenuHeight;
        if (this.lastHeaderHeight === currentHeight) {
            return;
        }
        this.lastHeaderHeight = currentHeight;
        this.$mainContent.css("margin-top", this.lastHeaderHeight);
    };
    return HeaderComponent;
}(app_1.Component));
exports.HeaderComponent = HeaderComponent;
var headerComponent = new HeaderComponent();
